import React from 'react';
import { useSelector } from 'react-redux';

import { NamedLink, Button } from '../../../components';

// Shared "List your items" call to action for the landing page.
// A logged-in seller goes straight to the new-listing page; a logged-out
// visitor is sent to sign up first. Keeping this in one place means every
// section behaves the same way.
const ListYourItemsButton = props => {
  const { buttonClassName, linkClassName, children } = props;
  const currentUser = useSelector(state => state.user.currentUser);
  const isLoggedIn = !!(currentUser && currentUser.id);
  const routeName = isLoggedIn ? 'NewListingPage' : 'SignupPage';

  return (
    <NamedLink className={linkClassName} style={{ textDecoration: 'none' }} name={routeName}>
      <Button className={buttonClassName}>{children}</Button>
    </NamedLink>
  );
};

export default ListYourItemsButton;
